import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/LayoutScreen/Home";
// import AuthGuard from "./services/guards/authguard";
import LayoutGuard from "./services/guards/layoutguard";
import { LoaderProvider } from "./components/loader/loader";
import Login from "./pages/CommonSreen/Login";
import Terms from "./pages/Terms & Conditions/Terms";
import Company from "./pages/companyScreen/company";
import BusinessBookView from "./pages/BusinessBookScreen/BusinessBookView";
import ErrorInterceptor from "./services/interceptors/errorInterceptor";
import FuelIndex from "./pages/FuelIndex/FuelIndex";
import LoadDetails from "./pages/LoadScreen/LoadDetails";
import Loads from "./pages/LoadScreen/Loadsviews";
import CreateContextService from "./services/CreateContextServices/CreateContextService";
import MarketResearchView from "./pages/MarketResearch/MarketResearchView";
import MarketNewReleaseView from "./pages/MarketNewRelease/MarketNewReleaseView";
import PlanViews from "./pages/Plan/PlanViews";
import IFtAdetails from "./pages/IFtAdetails";
import Dashboard from "./pages/Dashboard";
import Sales from "./pages/pipeline/Sales";
import PipelineForm from "./pages/pipeline/PipelineForm";
import NewStudent from "./pages/students/NewStudent";
import Ar from "./pages/accounting/Ar";
import Candidate from "./pages/candidate/Candidate";
import NewBizpartner from "./pages/bizpartners/NewBizpartner";
import MyProfile from "./pages/myprofile/MyProfile";
import CompanyProfile from "./pages/settings/Companyprofile";
import LiveSupport from "./pages/myprofile/LiveSupport";
import MarketingDetails from "./pages/marketing/MarketingDetails";
import AdmissionForm from "./pages/enrollment/AdmissionForm";
import New from "./pages/pipeline/New";
import InProgress from "./pages/pipeline/InProgress";
import Closed from "./pages/pipeline/Closed";
import Deleted from "./pages/pipeline/Deleted";
import InProgressStudent from "./pages/students/InProgressStudent";
import ClosedStudent from "./pages/students/ClosedStudent";
import StudentChart from "./pages/students/StudentChart";
import FunnelChartComponent from "./components/dashboard/FunnelChartComponent";
import EmptyDashboard from "./pages/EmptyDashboard";
import TrailUserPage from "./pages/trailUser/TrailUserPage";
import JobPage from "./pages/job/JobPage";
import TMSPage from "./pages/tms/TMSPage";
function App() {
  return (
    <>
      <CreateContextService>
        <LoaderProvider>
          <Router>
            <ErrorInterceptor />
            <Routes>
              <Route path="/" element={<Login />} />
              <Route path="/Login" element={<Login />} />
              <Route path="/enrollment" element={<AdmissionForm />} />


              <Route path="" element={<LayoutGuard><Home /></LayoutGuard>}>
                {/* <Route path="/Users" element={<LayoutGuard><Company /></LayoutGuard>} />
              <Route path="/Terms" element={<Terms />} />
              <Route path="/privacypolicy" element={<Privacypolicy/>} />
              <Route path="/FuelIndex" element={<FuelIndex />} />
              <Route path="/LoadDetails" element={<LoadDetails />} />
              <Route path="/Loads" element={<Loads />} />
              <Route path="/MarketResearch" element={<MarketResearchView />} />
              <Route path="/MarketNewRelease" element={<MarketNewReleaseView />} />
              <Route path="/Plan" element={<PlanViews />} /> */}
                <Route path="/Business" element={<LayoutGuard><BusinessBookView /></LayoutGuard>} />
                <Route path="/dashboard" element={<LayoutGuard><EmptyDashboard /></LayoutGuard>} />
                {/* <Route path="/IFTA" element={<IFtAdetails />} />
              <Route path="/pipeline/sales" element={<Sales />} /> */}
                {/* <Route path="/pipelineform" element={<PipelineForm />} /> */}
                {/* <Route path="/students/newstudent" element={<NewStudent />} />
              <Route path="/accounting/ar" element={<Ar />} />
              <Route path="/candidate/newcandidate" element={<Candidate />} />
              <Route path="/bizpartners/newbizpartners" element={<NewBizpartner />} /> */}
                <Route path="/myprofile" element={<LayoutGuard><MyProfile /></LayoutGuard>} />
                <Route path="/companyprofile" element={<LayoutGuard><CompanyProfile /></LayoutGuard>} />
                <Route path="/livesupport" element={<LayoutGuard><LiveSupport /></LayoutGuard>} />
                <Route path="/marketing" element={<LayoutGuard><MarketingDetails /></LayoutGuard>} />
                <Route
                  path="/trail-users"
                  element={
                    <LayoutGuard>
                      <TrailUserPage />
                    </LayoutGuard>
                  }
                />


                <Route
                  path="/job-openings"
                  element={
                    <LayoutGuard>
                      <JobPage />
                    </LayoutGuard>
                  }
                />

<Route
                  path="/tms"
                  element={
                    <LayoutGuard>
                      <TMSPage />
                    </LayoutGuard>
                  }
                />
                {/* <Route path="/policies/plans" element={<PoliciesPlans/>} /> */}
                {/* <Route path="/pipeline/new" element={<New />} /> */}
                {/* <Route path="/pipeline/inprogress" element={<InProgress />} /> */}
                {/* <Route path="/pipeline/closed" element={<Closed/>} /> */}
                {/* <Route path="/pipeline/deleted" element={<Deleted/>} /> */}
                {/* <Route path="/students/StudentChart" element={<StudentChart />}/> */}

                {/* <Route path="/students/inprogress" element={<InProgressStudent />} /> */}
                {/* <Route path="/students/closed" element={<ClosedStudent />} /> */}

              </Route>
            </Routes>
          </Router>
        </LoaderProvider>
      </CreateContextService>
    </>
  );
}

export default App;
